import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { Router, RouterModule } from '@angular/router';

import { NavbarComponent } from './components/navbar/navbar.component';
import { ConfirmModalComponent } from './modules/confirm-modal/confirm-modal.component';
import { IncludesActiveInLinksPipe } from './pipes/includes-active-in-links.pipe';
import { SafePipe } from './pipes/safe.pipe';
import { AuthService } from './services/auth.service';
import { AutoLogoutService } from './services/auto-logout.service';
import { NavbarService } from './services/navbar.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MatSidenavModule,
    MatExpansionModule,
    MatListModule,
    MatIconModule,
    NavbarComponent,
    ConfirmModalComponent,
    IncludesActiveInLinksPipe,
    SafePipe,
  ],
})
export class AppComponent {
  constructor(
    public navbarService: NavbarService,
    public router: Router,
    public authService: AuthService,
    private autoLogoutService: AutoLogoutService,
  ) {}
}
